import qs from 'qs';

export function getUrl(input, queryParams = {}) {
    const url = new URL(input, window.location.origin);

    url.search = qs.stringify(queryParams);

    return url.toString();
}
